// extracted by mini-css-extract-plugin
export default {"LikeControl__btn":"is_a"};